import { Component } from '@angular/core';
import { BaseCinchCardComponent } from '../base-cinch-card.component';

@Component({
  selector: 'cinch-card-secondary',
  templateUrl: './cinch-card-secondary.component.html',
  styleUrl: '../base-cinch-card.component.scss'
})
export class CinchCardSecondaryComponent extends BaseCinchCardComponent {

}
